import * as types from '../mutation-types';
import {
  get_promotions
} from '@/api/promotion';
export const state = {
  promotions: [],
  loading: false,
  meta: {}
}
export const getters = {
  loading: state => state.loading,
  promotions: state => state.promotions,
  meta: state => state.meta,

}
export const mutations = {
  [types.PROMOTION](state, payload) {
    state.loading = true;
  },
  [types.PROMOTION_SUCCESS](state, payload) {
    state.loading = false;
    state.promotions = payload.data;
    state.meta = payload.meta
  },
  [types.PROMOTION_FAIL](state, payload) {
    state.loading = false;
    state.promotions = [];
    state.meta = {}
  },

}
export const actions = {
  async get_promotions({ commit }, payload) {
    commit(types.PROMOTION);
    try {
      const data = await get_promotions(payload);
      commit(types.PROMOTION_SUCCESS, data)
    } catch (error) {
      commit(types.PROMOTION_FAIL);
    };
  },

}
